// frontend/src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Subscriptions from "./pages/Subscriptions";
// import SubscriptionLogin from "./pages/SubscriptionLogin";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Subscriptions />} />
      </Routes>
    </Router>
  );
}



















// // frontend/src/App.js
// import React, { useState, useEffect } from "react";
// import {
//   Elements,
//   PaymentElement,
//   useStripe,
//   useElements,
// } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

// function CheckoutForm({ email, setEmail }) {
//   const stripe = useStripe();
//   const elements = useElements();
//   const [isLoading, setIsLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!stripe || !elements) return;

//     setIsLoading(true);

//     const { error } = await stripe.confirmPayment({
//       elements,
//       confirmParams: {
//         return_url: "https://www.wurq.io/pages/success", // or your thank-you page
//         receipt_email: email,
//       },
//     });

//     if (error) {
//       setMessage(error.message);
//       setIsLoading(false);
//     }
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       style={{
//         maxWidth: 420,
//         margin: "80px auto",
//         background: "#fff",
//         borderRadius: "10px",
//         padding: "30px",
//         boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//       }}
//     >
//       <h2 style={{ textAlign: "center", marginBottom: 20 }}>Wurq Checkout</h2>

//       <label>Email</label>
//       <input
//         type="email"
//         required
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//         placeholder="Enter your email"
//         style={{
//           width: "100%",
//           padding: "10px",
//           marginBottom: "15px",
//           border: "1px solid #ccc",
//           borderRadius: "5px",
//         }}
//       />

//       <PaymentElement />

//       <button
//         type="submit"
//         disabled={!stripe || isLoading}
//         style={{
//           width: "100%",
//           marginTop: 20,
//           padding: "12px",
//           background: "#111827",
//           color: "#fff",
//           border: "none",
//           borderRadius: "6px",
//           cursor: "pointer",
//         }}
//       >
//         {isLoading ? "Processing..." : "Pay Now"}
//       </button>

//       {message && (
//         <p style={{ color: "red", marginTop: 10, textAlign: "center" }}>
//           {message}
//         </p>
//       )}
//     </form>
//   );
// }

// export default function App() {
//   const [clientSecret, setClientSecret] = useState("");
//   const [email, setEmail] = useState("");

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const mainPriceId = urlParams.get("mainPriceId");
//     const subsPriceId = urlParams.get("subsPriceId");
//     const quantity = urlParams.get("quantity") || 1;

//     if (!mainPriceId || !subsPriceId) {
//       console.error("Missing price IDs in URL");
//       return;
//     }

//     // 🧠 Create PaymentIntent from backend
//     async function createIntent() {
//       try {
//         const res = await fetch("http://localhost:5000/create-payment-intent", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ mainPriceId, subsPriceId, quantity }),
//         });
//         const data = await res.json();
//         setClientSecret(data.clientSecret);
//       } catch (err) {
//         console.error("Error creating payment intent:", err);
//       }
//     }

//     createIntent();
//   }, []);

//   const options = {
//     clientSecret,
//     appearance: {
//       theme: "flat",
//       variables: {
//         colorPrimary: "#111827",
//         fontFamily: "Inter, system-ui, sans-serif",
//       },
//     },
//   };

//   return (
//     <div>
//       {clientSecret && (
//         <Elements options={options} stripe={stripePromise}>
//           <CheckoutForm email={email} setEmail={setEmail} />
//         </Elements>
//       )}
//     </div>
//   );
// }
